// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading_1z-NWVoH2ixVcYYMv81WPP"};